export default __webpack_public_path__ + "static/media/camera_tampering.068d645b.png";